export var LogLevel;
(function (LogLevel) {
    LogLevel["LOG"] = "log";
    LogLevel["DEBUG"] = "debug";
    LogLevel["ERROR"] = "error";
    LogLevel["INFO"] = "info";
    LogLevel["WARN"] = "warning";
})(LogLevel || (LogLevel = {}));
export var NumericLogLevel;
(function (NumericLogLevel) {
    NumericLogLevel[NumericLogLevel["DEBUG"] = 4] = "DEBUG";
    NumericLogLevel[NumericLogLevel["LOG"] = 3] = "LOG";
    NumericLogLevel[NumericLogLevel["INFO"] = 2] = "INFO";
    NumericLogLevel[NumericLogLevel["WARN"] = 1] = "WARN";
    NumericLogLevel[NumericLogLevel["ERROR"] = 0] = "ERROR";
})(NumericLogLevel || (NumericLogLevel = {}));
export function logLevelToNumericLogLevel(lv) {
    switch (lv) {
        case (LogLevel.DEBUG):
            return NumericLogLevel.DEBUG;
        case (LogLevel.LOG):
            return NumericLogLevel.LOG;
        case (LogLevel.INFO):
            return NumericLogLevel.INFO;
        case (LogLevel.WARN):
            return NumericLogLevel.WARN;
        case (LogLevel.ERROR):
            return NumericLogLevel.ERROR;
    }
}
export function numericLogLevelToLogLevel(lv) {
    switch (lv) {
        case (NumericLogLevel.DEBUG):
            return LogLevel.DEBUG;
        case (NumericLogLevel.LOG):
            return LogLevel.LOG;
        case (NumericLogLevel.INFO):
            return LogLevel.INFO;
        case (NumericLogLevel.WARN):
            return LogLevel.WARN;
        case (NumericLogLevel.ERROR):
            return LogLevel.ERROR;
    }
}
